<template>
  <!-- 巨量番茄批量生成链接和商品 -->
  <div class="page-wrap">
    <div class="page-container">
      <!-- 搜索筛选卡片 -->
      <div class="search-card">
        <el-form inline :model="searchForm">
          <el-form-item label="短剧名称(精准):">
            <el-input placeholder="每行一个精准短剧名称，敲击回车换行" :rows="3" type="textarea" v-model="desc"
              @change="handleInputChange" style="width: 260px"></el-input>
          </el-form-item>
          <el-form-item label="平台编码:">
            <el-select v-model="platformCode" clearable placeholder="请选择平台编码" size="mini" style="width: 200px">
              <el-option v-for="item in platformList" :key="item.platformCode" :label="item.platformName"
                :value="item.platformCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短剧ID:">
            <el-input v-model="platformDramaId" placeholder="请精准输入短剧ID" clearable size="mini"
              style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="短剧名称(单个):">
            <el-input v-model="name" placeholder="可模糊查询" clearable size="mini" style="width: 200px"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="success" size="mini" @click="booklistSearchFun()">搜索</el-button>
            <el-button size="mini" @click="booklistResetFun()">重置</el-button>
          </el-form-item>
        </el-form>

        <!-- 搜索提示 -->
        <div class="search-tip">
          <el-icon class="search-tip-icon">
            <WarningFilled />
          </el-icon>
          <span>如果短剧不存在，请前往全域剧目管理添加短剧</span>
        </div>
      </div>

      <!-- 下方表格卡片 -->
      <div class="table-card">
        <!-- 工具栏：批量生成链接和商品 -->
        <div class="table-toolbar">
          <el-button type="primary" size="small" @click="batchCreateFun()">批量生成链接和商品</el-button>
          <el-button size="small" @click="openBatchLogFun()">查看批量日志</el-button>
          <span class="select-tip" v-if="selectRows.length > 0">
            已选 {{ selectRows.length }} 项
            <el-button type="text" size="small" @click="clearSelectionFun()">清空选择</el-button>
          </span>
        </div>
        <el-table ref="tableRef" :data="tableData" border stripe v-loading="loading" style="width: 100%"
          empty-text="请输入短剧名称再搜索数据" @selection-change="onSelectionChange">
          <el-table-column type="selection" width="55" />
          <!-- <el-table-column prop="platformCode" label="短剧平台" width="120"> </el-table-column> -->
          <el-table-column prop="name" label="短剧名称" min-width="220" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="type" label="类型"> </el-table-column>
          <el-table-column prop="platformDramaId" label="短剧ID" width="200"> </el-table-column>
          <el-table-column prop="playletId" label="专辑ID" width="200"> </el-table-column>
          <el-table-column prop="estimatePublishTime" label="预估投放时间" width="160"> </el-table-column>
          <!-- <el-table-column label="短剧图片" width="90">
            <template #default="scope">
              <el-image :src="scope.row.coverUrl" style="width: 50px;height: 50px;"
                :preview-src-list="[scope.row.coverUrl]" />
            </template>
</el-table-column> -->
          <el-table-column prop="totalEpisode" label="总集数" width="80"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <paginationMax50 @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
            :total="total" :pagesize="pagesize" :currentPage="currentPage"></paginationMax50>
        </div>
      </div>
    </div>

    <!-- 批量生成链接和商品弹窗 -->
    <el-dialog v-model="batchCreateView" title="批量生成链接和商品" width="620px" append-to-body destroy-on-close>
      <el-form :model="batchForm" label-width="130px" label-suffix=":" class="batch-form">
        <!-- <el-form-item label="应用版本">
          <el-radio-group v-model="batchForm.appVersion" size="small">
            <el-radio-button v-for="item in appVersionOptions" :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分销商配置">
          <el-radio-group v-model="batchForm.distributorMode" size="small">
            <el-radio-button v-for="item in distributorOptions" :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="IAA 分销商">
          <el-select v-model="batchForm.iaaDistributorId" placeholder="请选择" style="width: 100%" clearable>
            <el-option v-for="item in iaaOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="IAP 分销商">
          <el-select v-model="batchForm.iapDistributorId" placeholder="请选择" style="width: 100%" clearable>
            <el-option v-for="item in iapOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="付费面板">
          <el-checkbox-group v-model="batchForm.payLevels" size="small">
            <el-checkbox-button v-for="opt in payPanelOptions" :key="opt" :label="opt">{{ opt
            }}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="解锁集数">
          <el-select v-model="batchForm.unlockEpisodes" placeholder="第二章" style="width: 100%" multiple clearable>
            <el-option v-for="item in unlockEpisodeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="同步创建商品">
          <el-radio-group v-model="batchForm.syncCreateProduct" size="small">
            <el-radio-button v-for="item in syncProductOptions" :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
          <el-tooltip content="开启后将在生成推广链接的同时同步创建商品" placement="top">
            <el-icon class="sync-tip-icon">
              <InfoFilled />
            </el-icon>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="商品库来源组织" v-if="batchForm.syncCreateProduct === 1">
          <div class="org-select-box" @click="openOrgTreeFun()">
            <span v-if="productAccountName">{{ productAccountName }}</span>
            <span v-else class="org-placeholder">请选择组织账户</span>
            <el-icon class="org-arrow">
              <ArrowDown />
            </el-icon>
          </div>
        </el-form-item>
        <el-form-item label="商品库" v-if="batchForm.syncCreateProduct === 1">
          <el-select v-model="batchForm.productLibraryId" filterable placeholder="请先选组织，再选商品库"
            :disabled="!batchForm.productAccountId" style="width: 100%" clearable>
            <el-option v-for="item in productLibraryOptions" :key="item.platformId" :label="item.name"
              :value="item.platformId" />
          </el-select>
        </el-form-item>
        <el-form-item label="版权方名称" v-if="batchForm.syncCreateProduct === 1">
          <el-input v-model="batchForm.copyrightOwner" placeholder="请填写版权方主体名称" clearable />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="batchCreateView = false">取消</el-button>
        <el-button type="primary" :loading="batchSubmitting" @click="batchCreateConfirmFun()">确定</el-button>
      </template>
    </el-dialog>

    <!-- 组织账户选择弹窗 -->
    <el-dialog v-model="orgTreeView" title="选择组织账户" width="70%" append-to-body>
      <ylyOrganizationTree :datas="orgTreeType" @getOrgData="getOrgData"></ylyOrganizationTree>
    </el-dialog>

    <!-- 查看批量日志弹窗 -->
    <el-dialog v-model="batchLogView" title="查看批量日志" width="80%" append-to-body>
      <div class="search-card">
        <el-form inline :model="batchLogForm">
          <el-form-item label="批次号:">
            <el-input v-model="batchLogForm.batchNo" placeholder="请输入批次号（精准）" clearable size="mini"
              style="width: 300px"></el-input>
          </el-form-item>
          <!-- <el-form-item label="应用版本:">
            <el-radio-group v-model="batchLogForm.appVersion" size="small">
              <el-radio-button v-for="item in appVersionOptions" :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="批次状态:">
            <el-select v-model="batchLogForm.status" placeholder="请选择批次状态" clearable size="mini" style="width: 180px">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" size="mini" @click="batchLogSearchFun()">搜索</el-button>
            <el-button size="mini" @click="batchLogResetFun()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="batch-log-table">
        <el-table :data="batchLogData" border stripe v-loading="batchLogLoading" style="width: 100%">
          <el-table-column prop="batchNo" label="批次号" min-width="200" show-overflow-tooltip> </el-table-column>
          <el-table-column label="详情" width="90">
            <template #default="scope">
              <el-button type="text" size="small" @click="openBatchItemFun(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="appVersion" label="应用版本" width="90"> </el-table-column>
          <!-- <el-table-column prop="distributorMode" label="分销商配置" width="90"> </el-table-column> -->
          <el-table-column prop="copyrightOwner" label="版权方" min-width="140" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="批次状态" width="100">
            <template #default="scope">
              <el-tag size="mini" :type="statusTagType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="dramaCount" label="剧目数" width="80"> </el-table-column>
          <el-table-column prop="taskTotal" label="链接任务总数" width="110"> </el-table-column>
          <el-table-column label="链接成功数" width="100">
            <template #default="scope">
              <span class="num-success">{{ scope.row.linkSuccess }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkReused" label="链接复用数" width="100"> </el-table-column>
          <el-table-column label="链接失败数" width="100">
            <template #default="scope">
              <span class="num-fail">{{ scope.row.linkFail }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkWaiting" label="链接待投放数" width="110"> </el-table-column>
          <el-table-column label="商品成功数" width="100">
            <template #default="scope">
              <span class="num-success">{{ scope.row.productSuccess }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品失败数" width="100">
            <template #default="scope">
              <span class="num-fail">{{ scope.row.productFail }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createByName" label="创建人" width="90"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="170"> </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <paginationMax100 @handleSizeChange="handleLogSizeChange" @handleCurrentChange="handleLogCurrentChange"
            :total="batchLogTotal" :pagesize="batchLogPagesize" :currentPage="batchLogCurrentPage"></paginationMax100>
        </div>
      </div>
    </el-dialog>

    <!-- 批量日志详情弹窗 -->
    <el-dialog v-model="batchItemView" title="批次详情" width="90%" append-to-body>
      <div class="batch-log-table">
        <el-table :data="batchItemData" border stripe v-loading="batchItemLoading" style="width: 100%">
          <el-table-column type="index" label="#" width="50" />
          <el-table-column prop="dramaName" label="短剧名称" min-width="150" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="dramaType" label="短剧类型" width="80"> </el-table-column>
          <el-table-column prop="platformDramaId" label="平台短剧ID" min-width="170" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="明细类型" width="90">
            <template #default="scope">
              <span :class="itemTypeClass(scope.row.itemType)">{{ itemTypeText(scope.row.itemType) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkType" label="链接类型" width="80"> </el-table-column>
          <el-table-column prop="payLevel" label="付费档位" width="90"> </el-table-column>
          <el-table-column prop="episode" label="解锁集数" width="80"> </el-table-column>
          <el-table-column prop="panelName" label="面板名称" min-width="150" show-overflow-tooltip> </el-table-column>
          <el-table-column label="推广链接" width="90">
            <template #default="scope">
              <el-button v-if="scope.row.promotionUrl" type="text" size="small"
                @click="copyUrlFun(scope.row.promotionUrl)">复制</el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="productId" label="商品ID" min-width="160" show-overflow-tooltip> </el-table-column>
          <el-table-column label="状态" width="90">
            <template #default="scope">
              <el-tag size="mini" :type="itemStatusTagType(scope.row.status)">{{ itemStatusText(scope.row.status)
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="errorMsg" label="失败原因" min-width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="160"> </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" min-width="160"> </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <paginationMax100 @handleSizeChange="handleItemSizeChange" @handleCurrentChange="handleItemCurrentChange"
            :total="batchItemTotal" :pagesize="batchItemPagesize" :currentPage="batchItemCurrentPage">
          </paginationMax100>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { booklist, bookplatformList, librarylist, batchLinkItemPage, batchLinkBatchPage, batchLinkSubmit, bookCheckPlayletIds } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { reactive, toRefs, ref, watch } from 'vue'
import paginationMax100 from '@/components/paginationMax100.vue' // 批量日志、明细列表分页（最多100条/页）
import paginationMax50 from '@/components/paginationMax50.vue' // 主列表分页（最多50条/页）
import ylyOrganizationTree from '@/components/ylyBatch/ylyOrganizationTree.vue' // 组织账户树选择

export default {
  name: 'ylyPLPromotionAndProduct',
  components: { paginationMax100, ylyOrganizationTree, paginationMax50 },
  setup() {
    // 表格实例（多选清空用）
    const tableRef = ref(null)
    const state = reactive({
      // 平台编码（精确）
      platformCode: '',
      // 平台短剧ID（精确）
      platformDramaId: '',
      // 短剧名称（模糊、单个）
      name: '',
      // 批量精准短剧名称的输入原始文本
      desc: '',
      // 批量精准短剧名称数组
      names: [],
      // 平台下拉数据
      platformList: [],
      // 表格数据
      tableData: [],
      // 表格 loading
      loading: false,
      // 多选勾选的行
      selectRows: [],
      // 多选勾选行变化
      onSelectionChange: (val) => {
        state.selectRows = val || []
      },
      // 清空多选
      clearSelectionFun: () => {
        tableRef.value?.clearSelection()
      },
      // 批量生成弹窗
      batchCreateView: false,
      // 批量生成提交中（防重复点击）
      batchSubmitting: false,
      // 批量生成链接和商品：先校验是否勾选，通过再打开弹窗
      batchCreateFun: () => {
        if (state.selectRows.length === 0) {
          return ElMessage.warning('请先勾选需要生成的短剧数据')
        }
        state.batchCreateView = true
      },
      // 重置弹窗表单数据
      resetBatchFormFun: () => {
        state.batchForm = {
          appVersion: 'R3',
          distributorMode: 'MULTI',
          iaaDistributorId: '1855633968499848',
          iapDistributorId: '1855633968499864',
          payLevels: ['中额'],
          unlockEpisodes: [],
          syncCreateProduct: 1,
          productAccountId: '',
          productLibraryId: '',
          copyrightOwner: '',
        }
        state.productAccountName = ''
        state.productLibraryOptions = []
      },
      // 批量生成弹窗表单
      batchForm: {
        // 应用版本：R1 / R3，默认 R3
        appVersion: 'R3',
        // 分销商配置：SINGLE 单分销商 / MULTI 多分销商
        distributorMode: 'MULTI',
        // IAA 分销商
        iaaDistributorId: '1855633968499848',
        // IAP 分销商
        iapDistributorId: '1855633968499864',
        // 付费面板（多选）
        payLevels: ['中额'],
        // 广告解锁集数（多选）
        unlockEpisodes: [],
        // 同步创建商品：0 不开启 / 1 开启
        syncCreateProduct: 1,
        // 商品库来源组织
        productAccountId: '',
        // 商品库
        productLibraryId: '',
        // 版权方名称
        copyrightOwner: '',
      },
      // 应用版本选项（R1/R3，默认R3）
      appVersionOptions: [
        { label: '全域R3', value: 'R3' },
        { label: '标准R1', value: 'R1' },
      ],
      // 分销商配置选项（SINGLE 单分销商 / MULTI 多分销商）
      distributorOptions: [
        { label: '单分销商', value: 'SINGLE' },
        { label: '多分销商', value: 'MULTI' },
      ],
      // 付费面板选项
      payPanelOptions: ['中额', '小额', '超小额', '超超小额'],
      // 同步创建商品选项（0 不开启 / 1 开启）
      syncProductOptions: [
        { label: '不开启', value: 0 },
        { label: '开启', value: 1 },
      ],
      // IAA 分销商下拉
      iaaOptions: [
        { label: '端原生免费漫剧', value: '1855633968499848' },
        { label: '端原生免费短剧', value: '1851001214864424' },
      ],
      // IAP 分销商下拉
      iapOptions: [
        { label: '端原生付费漫剧', value: '1855633968499864' },
        { label: '端原生付费短剧', value: '1851001214864440' },
      ],
      // 解锁集数下拉：第一章~第二十章，值 1~20
      unlockEpisodeOptions: Array.from({ length: 20 }, (v, i) => ({
        label: `第${i + 1}章`,
        value: i + 1,
      })),
      // 商品库来源组织名称（显示用）
      productAccountName: '',
      // 商品库下拉数据（依赖来源组织）
      productLibraryOptions: [],
      // 组织账户树弹窗
      orgTreeView: false,
      // 组织树选择来源标识
      orgTreeType: 'setSpType',
      // 打开组织账户树
      openOrgTreeFun: () => {
        state.orgTreeView = true
        state.orgTreeType = 'setSpType'
      },
      // 接收组织树选择结果
      getOrgData: (data) => {
        if (data.type === 'setSpType') {
          state.batchForm.productAccountId = data.id
          state.productAccountName = data.name
          // 切换组织后清空已选商品库并重新拉取
          state.batchForm.productLibraryId = ''
          state.productLibraryOptions = []
          librarylistFun()
        }
        state.orgTreeView = false
      },
      // 弹窗确定：先校验所选短剧的专辑ID，全部存在后再提交批量生成
      batchCreateConfirmFun: () => {
        if (state.selectRows.length === 0) {
          return ElMessage.warning('请先勾选需要生成的短剧数据')
        }
        if (state.batchSubmitting) return
        const platformDramaIds = state.selectRows.map((row) => String(row.platformDramaId))
        state.batchSubmitting = true
        bookCheckPlayletIds({ platformDramaIds })
          .then((res) => {
            if (res.code !== 200) return
            const invalidList = Array.isArray(res.data) ? res.data : []
            // 有缺失的抖音专辑ID：停止后续流程，提示信息由后端 msg 给出
            if (invalidList.length > 0) {
              return ElMessage.error({
                dangerouslyUseHTMLString: true,
                message: (res.msg || '没有找到抖音专辑ID，需要补充专辑ID后再操作后续流程').replace(
                  /：/,
                  '：<br/>'
                ),
              })
            }
            return batchLinkSubmit(buildBatchSubmitDatas()).then((submitRes) => {
              if (submitRes.code === 200) {
                ElMessage.success('提交成功')
                state.batchCreateView = false
                state.resetBatchFormFun()
                tableRef.value?.clearSelection()
                booklistFun()
              }
            })
          })
          .finally(() => {
            state.batchSubmitting = false
          })
      },
      // 批量日志弹窗
      batchLogView: false,
      // 批量日志筛选表单
      batchLogForm: {
        batchNo: '',
        // 应用版本默认全域R3
        appVersion: 'R3',
        status: '',
      },
      // 批次状态下拉（0待执行 1执行中 2完成）
      statusOptions: [
        { label: '待执行', value: 0 },
        { label: '执行中', value: 1 },
        { label: '完成', value: 2 },
      ],
      // 批量日志表格数据
      batchLogData: [],
      // 批量日志 loading
      batchLogLoading: false,
      // 批量日志 条数
      batchLogPagesize: 20,
      // 批量日志 当前页数
      batchLogCurrentPage: 1,
      // 批量日志 总数
      batchLogTotal: 0,
      // 批量日志 页数发生改变
      handleLogCurrentChange: (e) => {
        state.batchLogCurrentPage = e
        batchLogPageFun()
      },
      // 批量日志 个数发生改变
      handleLogSizeChange: (e) => {
        state.batchLogPagesize = e
        state.batchLogCurrentPage = 1
        batchLogPageFun()
      },
      // 打开批量日志弹窗
      openBatchLogFun: () => {
        state.batchLogView = true
        state.batchLogCurrentPage = 1
        batchLogPageFun()
      },
      // 批量日志 搜索
      batchLogSearchFun: () => {
        state.batchLogCurrentPage = 1
        batchLogPageFun()
      },
      // 批量日志 重置
      batchLogResetFun: () => {
        state.batchLogForm.batchNo = ''
        state.batchLogForm.appVersion = 'R3'
        state.batchLogForm.status = ''
        state.batchLogCurrentPage = 1
        batchLogPageFun()
      },
      // 批次状态文案
      statusText: (status) => {
        const map = { 0: '待执行', 1: '执行中', 2: '完成' }
        return map[status] || ''
      },
      // 批次状态标签样式
      statusTagType: (status) => {
        const map = { 0: 'info', 1: 'warning', 2: 'success' }
        return map[status] || ''
      },
      // 明细类型文案：LINK打链 / PRODUCT建商品
      itemTypeText: (itemType) => {
        const map = { LINK: '打链', PRODUCT: '建商品' }
        return map[itemType] || itemType || ''
      },
      // 明细类型颜色：打链蓝色 / 建商品绿色
      itemTypeClass: (itemType) => {
        return itemType === 'PRODUCT' ? 'item-type-product' : 'item-type-link'
      },
      // 明细状态文案：0待执行 1成功 2失败 3复用/等待链接 4待投放 5执行中
      itemStatusText: (status) => {
        const map = {
          0: '待执行',
          1: '成功',
          2: '失败',
          3: '复用/等待链接',
          4: '待投放',
          5: '执行中',
        }
        return map[status] || ''
      },
      // 明细状态标签样式
      itemStatusTagType: (status) => {
        const map = {
          0: 'info',
          1: 'success',
          2: 'danger',
          3: 'warning',
          4: 'info',
          5: 'warning',
        }
        return map[status] || ''
      },
      // 复制文本
      copyUrlFun: (text) => {
        navigator.clipboard.writeText(text)
        ElMessage.success('复制成功')
      },
      // 批次详情弹窗
      batchItemView: false,
      // 当前批次id
      currentBatchId: '',
      // 批次详情表格数据
      batchItemData: [],
      // 批次详情 loading
      batchItemLoading: false,
      // 批次详情 条数
      batchItemPagesize: 20,
      // 批次详情 当前页数
      batchItemCurrentPage: 1,
      // 批次详情 总数
      batchItemTotal: 0,
      // 批次详情 页数发生改变
      handleItemCurrentChange: (e) => {
        state.batchItemCurrentPage = e
        batchItemPageFun()
      },
      // 批次详情 个数发生改变
      handleItemSizeChange: (e) => {
        state.batchItemPagesize = e
        state.batchItemCurrentPage = 1
        batchItemPageFun()
      },
      // 打开批次详情弹窗（携带当前行id）
      openBatchItemFun: (row) => {
        state.currentBatchId = row.id
        state.batchItemView = true
        state.batchItemCurrentPage = 1
        batchItemPageFun()
      },
      // 条数
      pagesize: 50,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 0,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        booklistFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        state.currentPage = 1
        booklistFun()
      },
      // 监听把输入的数据变成短剧名称数组
      handleInputChange: () => {
        state.names = parseNames()
      },
      // 搜索：回到第一页再查
      booklistSearchFun: () => {
        state.currentPage = 1
        booklistFun()
      },
      // 重置筛选条件
      booklistResetFun: () => {
        state.platformCode = ''
        state.platformDramaId = ''
        state.name = ''
        state.desc = ''
        state.names = []
        state.currentPage = 1
        state.tableData = []
        state.total = 0
        ElMessage.info('已重置筛选条件，请输入短剧名称(精准)、短剧名称(单个)或短剧ID后再搜索')
      },
    })

    // 关闭同步创建商品时，清空商品相关已选项，避免残留脏数据
    watch(
      () => state.batchForm.syncCreateProduct,
      (val) => {
        if (val !== 1) {
          state.batchForm.productAccountId = ''
          state.batchForm.productLibraryId = ''
          state.batchForm.copyrightOwner = ''
          state.productAccountName = ''
          state.productLibraryOptions = []
        }
      }
    )

    // 组装批量生成提交参数
    const buildBatchSubmitDatas = () => {
      return {
        dramaIds: state.selectRows.map((row) => String(row.platformDramaId)),
        appVersion: state.batchForm.appVersion,
        distributorMode: state.batchForm.distributorMode,
        iaaDistributorId: state.batchForm.iaaDistributorId,
        iapDistributorId: state.batchForm.iapDistributorId,
        payLevels: state.batchForm.payLevels,
        unlockEpisodes: state.batchForm.unlockEpisodes,
        syncCreateProduct: state.batchForm.syncCreateProduct,
        // 未开启同步创建商品时，不提交商品相关参数
        productAccountId:
          state.batchForm.syncCreateProduct === 1 ? String(state.batchForm.productAccountId) : '',
        productLibraryId:
          state.batchForm.syncCreateProduct === 1 ? String(state.batchForm.productLibraryId) : '',
        copyrightOwner: state.batchForm.syncCreateProduct === 1 ? state.batchForm.copyrightOwner : '',
      }
    }

    // 解析「短剧名称(精准)」输入框内容为名称数组
    const parseNames = () => {
      return (state.desc || '')
        .split('\n')
        .map((item) => item.trim())
        .filter((item) => item !== '')
    }

    // 分页查询当前登录用户的短剧
    const booklistFun = () => {
      const names = parseNames()
      const name = (state.name || '').trim()
      const platformDramaId = (state.platformDramaId || '').trim()
      // 必须至少满足一个条件：短剧名称(精准)、短剧名称(单个)、短剧ID
      if (names.length === 0 && !name && !platformDramaId) {
        state.loading = false
        state.tableData = []
        state.total = 0
        ElMessage.warning('请至少填写短剧名称(精准)、短剧名称(单个)、短剧ID其中一项后再查询')
        return
      }
      state.loading = true
      const datas = {
        platformCode: state.platformCode,
        platformDramaId,
        name,
        currentPage: state.currentPage,
        size: state.pagesize,
        names,
      }
      booklist(datas)
        .then((res) => {
          const data = res.data || {}
          state.currentPage = data.currenPage
          state.total = data.totalSize
          state.tableData = data.data || []
        })
        .finally(() => {
          state.loading = false
        })
    }

    // 分销平台下拉框（查询所有启用的平台）
    const bookplatformListFun = () => {
      bookplatformList().then((res) => {
        state.platformList = res.data || []
      })
    }

    // 查询商品库（依赖来源组织）
    const librarylistFun = () => {
      if (!state.batchForm.productAccountId) {
        ElMessage.error('请先选择组织')
        return
      }
      const datas = {
        accountId: state.batchForm.productAccountId,
        currenPage: 1,
        size: 1000,
      }
      librarylist(datas).then((res) => {
        state.productLibraryOptions = res.data.data || []
        if (state.productLibraryOptions.length === 0) {
          ElMessage.error('商品库为空！！！请排查：检查该组织是否有商品库')
        }
      })
    }

    // 批量日志分页查询
    const batchLogPageFun = () => {
      state.batchLogLoading = true
      const datas = {
        currentPage: state.batchLogCurrentPage,
        size: state.batchLogPagesize,
        batchNo: state.batchLogForm.batchNo,
        appVersion: state.batchLogForm.appVersion,
        status: state.batchLogForm.status,
      }
      batchLinkBatchPage(datas)
        .then((res) => {
          const data = res.data || {}
          state.batchLogCurrentPage = data.currenPage
          state.batchLogTotal = data.totalSize
          state.batchLogData = data.data || []
        })
        .finally(() => {
          state.batchLogLoading = false
        })
    }

    // 批次明细分页查询
    const batchItemPageFun = () => {
      state.batchItemLoading = true
      const datas = {
        batchId: state.currentBatchId,
        currentPage: state.batchItemCurrentPage,
        size: state.batchItemPagesize,
      }
      batchLinkItemPage(datas)
        .then((res) => {
          const data = res.data || {}
          state.batchItemCurrentPage = data.currenPage
          state.batchItemTotal = data.totalSize
          state.batchItemData = data.data || []
        })
        .finally(() => {
          state.batchItemLoading = false
        })
    }

    // 首次进入页面不请求短剧列表，需用户填写查询条件后主动搜索
    bookplatformListFun()

    return {
      ...toRefs(state),
      tableRef,
      booklistFun,
      bookplatformListFun,
      batchLogPageFun,
      batchItemPageFun,
    }
  },
}
</script>

<style lang="scss" scoped>
// 全局页面浅色渐变背景
// 外层 .home 是 100vh + overflow: hidden，页面必须自己限高并内部滚动，否则多条数据时会被裁掉且无滚动条
.page-wrap {
  height: calc(100vh - 70px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
  box-sizing: border-box;
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

// 搜索卡片：毛玻璃、大圆角、弥散柔和阴影
.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
}

// 表格卡片
.table-card {
  border-radius: 18px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  overflow: hidden;
}

.pagination-wrap {
  padding: 12px 4px 4px;
  display: flex;
  justify-content: center;
}

// 批量日志表格区
.batch-log-table {
  margin-top: 16px;
}

// 明细类型颜色：打链蓝色 / 建商品绿色
.item-type-link {
  color: #409eff;
}

.item-type-product {
  color: #00b42a;
}

// 统计数字颜色：成功绿色 / 失败红色
.num-success {
  color: #00b42a;
  font-weight: 600;
}

.num-fail {
  color: #f53f3f;
  font-weight: 600;
}

// 表格上方工具栏
.table-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.select-tip {
  font-size: 13px;
  color: #909399;
}

// 搜索卡片下方的红字提示
.search-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-size: 13px;
  color: #f56c6c;
  line-height: 1.5;
}

.search-tip-icon {
  font-size: 14px;
  color: #f56c6c;
}

// 批量生成弹窗内提示
.batch-form {
  padding-right: 10px;
}

// 同步创建商品旁的提示图标
.sync-tip-icon {
  margin-left: 10px;
  color: #909399;
  cursor: help;
  vertical-align: middle;
}

// 商品库来源组织选择框（点击打开组织树）
.org-select-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 13px;
  color: #303133;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.2s;

  &:hover {
    border-color: #c0c4cc;
  }

  .org-placeholder {
    color: #a8abb2;
  }

  .org-arrow {
    color: #a8abb2;
  }
}

:deep(.el-input__inner),
:deep(.el-select .el-input__inner) {
  border-radius: 12px !important;
}

:deep(.el-table) {
  border-radius: 14px;
  overflow: hidden;
}

:deep(.el-table th.el-table__cell) {
  background-color: #f4f7fc !important;
}
</style>
